import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotificationModule } from '@appkit4/angular-components/notification';
import { appInitializeTranslationFactory } from '@core/app-initialize-translation-factory';
import { AuthInterceptor } from '@core/auth.interceptor';
import { ErrorsHandlerInterceptor } from '@core/errors-handler.interceptor';
import { LoaderInterceptor } from '@core/loader.interceptor';
import { NgIdleModule } from '@ng-idle/core';
import { TranslateService, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import * as GlobalUtils from '@shared/helpers/utils';
import { GLOBAL_UTILS } from '@shared/tokens/utils.token';
import { provideHighcharts } from 'highcharts-angular';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WINDOW_PROVIDERS } from './core/window.service';
import { SharedModule } from './shared/shared.module';
import { API_BASE_URL, GstarClient } from './web-api-client';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgIdleModule.forRoot(),
    NotificationModule,
  ],
  providers: [
    WINDOW_PROVIDERS,
    { provide: GLOBAL_UTILS, useValue: GlobalUtils },
    { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorsHandlerInterceptor,
      multi: true,
    },
    GstarClient,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: appInitializeTranslationFactory,
      deps: [TranslateService],
    },
    provideTranslateService(),
    ...provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
    provideHighcharts({
      instance: () => import('highcharts/esm/highmaps').then(m => m.default),
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
